// Legal document content, generated from the source .docx files.
// Regenerate with scripts/convert-legal-docs.py after updating a document,
// then bump the version in the .docx front matter — signup consent is recorded
// against the versions exported here.
import privacyPolicy from './privacyPolicy.json';
import termsOfUse from './termsOfUse.json';

export const TERMS_OF_USE_PATH = '/terms-of-use';
export const PRIVACY_POLICY_PATH = '/privacy-policy';

export const LEGAL_VERSIONS = {
    termsOfUse: termsOfUse.meta.version,
    privacyPolicy: privacyPolicy.meta.version,
};

export { privacyPolicy, termsOfUse };
